import React from "react";

export const Page12Tamil = () => {
  return (
    <div className="page-tamil-container">
      <h1>ஆலய வழிபாட்டு முறைகள்</h1>
      <h1>பக்தர்கள் தாங்களே பின்பற்ற வேண்டிய பத்து கட்டளைகள் :</h1>
      <p>1. கோயிலில் உள்ள எல்லா தெய்வங்களையும் வணங்க வேண்டும். </p>
      <p>2. பிரகாரத்தை வலப்புறமாகச் சுற்றி மெதுவாக நடந்து வலம் வர வேண்டும்.</p>
      <p>
        3. கோயிலில் வலம் வரும் போது வெற்றிலை போடுதல், பொடி போடுதல், புகையிலை
        போடுதல், புகைப் பிடித்தல், போதைப் பொருள் உபயோகித்தல் தவிர்க்க வேண்டும்.
        ஏதாவது தின்று கொண்டும் கோயிலை சுற்றுதல் கூடாது
      </p>
      <p>
        4. தலையில் முண்டாசு, தொப்பி, காலில் காலணி அணிந்து கொண்டு கோயிலுக்குள்
        செல்லக்கூடாது
      </p>
      <p>5. இரு கைகளையும் ஒன்றாக கூப்பி வணங்க வேண்டும்.</p>
      <p>
        6. உடன் வருபவர்களுடன் வீண் வார்த்தைகள் மற்றும், பக்தர்கள் மனம்
        புண்படும்படியாக பேச்சுக்களை பேசி வலம் வரக்கூடாது.{" "}
      </p>
      <p>7. குளிக்காமல் கோயிலுக்குள் செல்லக்கூடாது.</p>
      <p>8. இரவில் தீபம் இல்லாத போது சுவாமியை தரிசிக்கக் கூடாது.</p>
      <p>9. கோயிலுக்குள் உயர்ந்த ஆசனத்தில் அமரக்கூடாது. </p>
      <p>
        10. கோயிலில் வழங்கும் பிரசாதத்தை (விபூதி குங்குமம்) பக்குவமாக பெற்று
        பயன்படுத்த வேண்டும்
      </p>
    </div>
  );
};
